import {
  Alert,
  Button,
  Card,
  Checkbox,
  DatePicker,
  Form,
  message,
  notification,
  Progress,
  Result,
  Space,
  Upload,
} from "antd";
import React, { useEffect, useState } from "react";
import { InboxOutlined } from "@ant-design/icons";
import { postFile } from "../../../services/EndPointApiService";
import { ProFormField, ProTable } from "@ant-design/pro-components";
import { Container, Label } from "reactstrap";

const UploadReportShopee = () => {
  const [loading, setLoading] = useState(false);
  const [downloadDate, setDownloadDate] = useState(null);
  const [replace, setReplace] = useState(false);

  const [resultFile, setResultFile] = useState([]);
  const [allowUpload, setAllowUpload] = useState(false);
  const [pendingFormData, setPendingFormData] = useState(null);

  const [proccessFinish, setProccessFinish] = useState(false);
  const [proccessResult, setProccessResult] = useState(null);

  const initPage = () => {
    setResultFile([]);
    setAllowUpload(false);
    setProccessFinish(false);
    setPendingFormData(null);
    setProccessResult(null);
  };

  useEffect(() => {
    initPage();
  }, []);

  return (
    <>
      <Container>
        <Card>
          <Form>
            <ProFormField>
              <ProFormField>
                <Space>
                  <Label>Please Select Date</Label>
                  <DatePicker
                    onChange={(date, dateString) => {
                      console.log(date, dateString);
                      setDownloadDate(dateString);
                    }}
                  />
                </Space>
              </ProFormField>
            </ProFormField>
            <ProFormField>
              <Checkbox
                onChange={(e) => {
                  console.log(e);
                  setReplace(e.target.checked);
                }}
              />
              &nbsp;
              <Label>Replace existing data with same download date </Label>
            </ProFormField>

            <Upload
              multiple={false}
              name="file"
              type="drag"
              showUploadList={false}
              disabled={loading}
              beforeUpload={async (file) => {
                initPage();
                setLoading(true);
                message.warning("Uploading your file please wait");
                let postUrl = "upload/Dynamic";
                let formData = new FormData();
                formData.append("file", file);
                const result = await postFile(postUrl, formData);
                const resultData = result.data;
                setResultFile(resultData);
                setPendingFormData(formData);
                setAllowUpload(resultData?.data?.length > 0);
                message.success("File Uploaded");
                setLoading(false);
                return false;
              }}
            >
              <p className="ant-upload-drag-icon">
                <InboxOutlined />
              </p>
              <p className="ant-upload-text">Upload Report Shopee</p>
              <p className="ant-upload-hint">
                Click or drag your file here. Please provide valid file before
                uploading
              </p>
              <Button disabled={loading} loading={loading} size="large">
                Upload Report Shopee
              </Button>
            </Upload>
            <br />
            <br />

            {allowUpload && !proccessFinish && (
              <>
                {loading && (
                  <Progress
                    showInfo={false}
                    percent={99.9}
                    status="active"
                    strokeColor={{ from: "#108ee9", to: "#87d068" }}
                  />
                )}
                <Alert
                  message={
                    loading
                      ? "Please wait your upload in progress..."
                      : "Your Files Ready to Process"
                  }
                  type={loading ? "warning" : "info"}
                  showIcon
                />
                <ProTable
                  headerTitle={
                    <div style={{ color: "#FF1212" }}>
                      Always check file before process
                    </div>
                  }
                  scroll={{
                    x: "max-content",
                  }}
                  cardProps={false}
                  search={false}
                  toolbar={{
                    search: false,
                    settings: false,
                    actions: !allowUpload
                      ? []
                      : [
                          <Button
                            size="large"
                            key={"uploadFile"}
                            type="primary"
                            loading={loading}
                            disabled={!downloadDate}
                            onClick={async () => {
                              message.warning(
                                "Uploading your data. Please wait..."
                              );
                              setLoading(true);
                              const result = await postFile(
                                "upload/ReportShopee/" +
                                  downloadDate +
                                  "/" +
                                  replace,
                                pendingFormData
                              );
                              const resultData = result.data;
                              if (resultData.status === "Success") {
                                notification.success({
                                  message: "Upload Data",
                                  description: resultData.message,
                                });
                              } else {
                                notification.error({
                                  message: "Upload Data",
                                  description: resultData.message,
                                });
                              }
                              setProccessResult(resultData);
                              setProccessFinish(true);
                              setLoading(false);
                            }}
                          >
                            Process Upload
                          </Button>,
                        ],
                  }}
                  columns={resultFile.columns.map((c) => ({
                    key: c,
                    title: c,
                    dataIndex: c,
                  }))}
                  dataSource={resultFile.data.map((d, i) => ({ ...d, key: i }))}
                />
              </>
            )}

            {proccessFinish && (
              <Result
                status={
                  proccessResult.status === "Success" ? "success" : "error"
                }
                title={"Upload Process " + proccessResult.status}
                subTitle={proccessResult.message}
              />
            )}
          </Form>
        </Card>
      </Container>
    </>
  );
};

export default UploadReportShopee;
